import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const AdminRoute = ({ children }) => {
	const role = useSelector((state) => state.user.currentOrg?.orgRole)

	if (role === undefined) return null // or a loader

	return role === 'admin' ? children : <Navigate to='/' replace />
}

export default AdminRoute
